import { initReactI18next } from 'react-i18next';

import i18n, { InitOptions, ReadCallback } from 'i18next';
import ICU from 'i18next-icu';
import resourcesToBackend from 'i18next-resources-to-backend';

const loadLocalFile = (language: string, namespace: string, callback: ReadCallback) => {
  import(`./locales/${language}/${namespace}.json`)
    .then((module) => callback(null, module.default || module))
    .catch((error) => {
      console.error(`Failed to load translations for ${language}/${namespace}:`, error);
      callback(error, null);
    });
};

export const initI18n = (options: InitOptions) => {
  return i18n
    .use(ICU)
    .use(initReactI18next)
    .use(resourcesToBackend(loadLocalFile))
    .init({
      ...options,
      react: {
        useSuspense: true,
        ...options.react,
      },
    });
};